const NS = 'SectionNavigatorWidget';
const CLS = 'sectionNavigatorWidget';

import { scrollIntoView } from 'scroll-js';

export class SectionNavigatorWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$tplScroller = $('.tpl-scroller');
		this.$blocks = $('[data-section-navigator-container]').children();

		this.$navigation;
		this.$navigationActiveItem = null;
		this.scrollDuration = 750;
		this.scrollEasing = 'ease-in-out';
		this.$knowledgeCheckBlock = $('[data-blk="KnowledgeCheckBlock"]');

		if(this.$blocks.length > 0) {
			this.createNavigator();
			this.setScrollEvent();
			this.setActiveNavigationItem();
		}
	}

	createNavigator() {
		this.$blocks.each((index, element) => {
			$(element).addClass(`section section--${index + 1}`);
		});

		let knowledgeCheckBlockIndex = this.$blocks.filter(this.$knowledgeCheckBlock).index();
		let getNavigationItemsTemplate = () => {
			let list = `<ul class="${CLS}-list">`;

			this.$blocks.each((index, _element) => {
				list += `<li class="${CLS}-item ${knowledgeCheckBlockIndex === index ? `${CLS}-item--knowledgeCheck`: ''}">
					<a data-block=".section--${index + 1}" id="${CLS}-link--${index + 1}" class="${CLS}-link ">
					</a>
				</li>`;
			});
			list += `</ul>`;
			return list;
		};

		this.$element.append(getNavigationItemsTemplate());
		this.$navigation = this.$element.find(`.${CLS}-list`);
		this.$navigation.find(`a.${CLS}-link`).on('click', (event) => {
			let section = $($(event.target).attr('data-block'))[0];
			scrollIntoView(section, this.$tplScroller[0], { duration: this.scrollDuration, easing: this.scrollEasing }).then();
		});

		if(this.$knowledgeCheckBlock && this.$knowledgeCheckBlock.length > 0) {
			let $knowledgeCheckLink = this.$element.find(`.${CLS}-knowledgeCheckLink`);
			$knowledgeCheckLink.on('click', () => {
				scrollIntoView(this.$knowledgeCheckBlock[0], this.$tplScroller[0], { duration: this.scrollDuration, easing: this.scrollEasing }).then();
			});
		}
	}

	setScrollEvent() {
		this.$tplScroller.on('scroll', _.throttle(() => {
			this.setActiveNavigationItem();
		}, 250));
	}

	setActiveNavigationItem() {
		this.$blocks.each((index, element) => {
			if(0 >= Math.floor($(element).position().top)) {
				let navigationItem = this.$navigation.find(`#${CLS}-link--${index + 1}`);

				if(this.$navigationActiveItem) {
					this.$navigationActiveItem.removeClass(`active`);
				}

				if(this.$navigationActiveItem !== navigationItem) {
					this.$navigationActiveItem = navigationItem;
					this.$navigationActiveItem.addClass(`active`);
				}
			}
		});

		if(!this.$navigationActiveItem) {
			if(this.$navigation.find(`.${CLS}-link`).length > 0) {
				this.$navigationActiveItem = this.$navigation.find(`#${CLS}-link--1`);
				this.$navigationActiveItem.addClass('active');
			}
		}
	}
}
